<template>
  <el-dialog :title="title" :visible.sync="visible" :close-on-click-modal="false" append-to-body @opened="openFun">
    <el-form :model="entity" :rules="rules" ref="flowRef" label-width="120px">
      <el-form-item label="订单号" prop="orderNo">
        <el-input v-model="entity.orderNo" disabled></el-input>
      </el-form-item>
      <el-form-item label="还款期数" prop="id">
        <el-select v-model="entity.id" clearable placeholder="请选择还款期数" style="width: 100%">
          <el-option v-for="item in repaymentList" :key="item.id" :label="stringRepayment(item)" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="resetForm('flowRef')">重置</el-button>
      <el-button type="primary" :loading="isLoading" @click="submitForm('flowRef')">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {successMsg} from "@/utils/message";
import {orderRepay, orderRepayList} from "@/api/order/order";

export default {
  name: "orderRepayDialog",
  components: {},
  props: {
    dialogVisible: {
      type: Boolean,
      require: true,
      default: false
    },
    orderNo: {
      type: String,
      require: true,
      default: ''
    }
  },
  computed: {
    visible: {
      get: function () {
        return this.dialogVisible
      },
      set: function (val) {
        this.$emit('update:dialogVisible', val)
      }
    }
  },
  data() {
    return {
      title: '还款',
      isLoading: false,
      entity: {
        orderNo: '',
        id: ''
      },
      rules: {
        orderNo: [{required: true, message: '订单号不能为空', trigger: 'blur'}],
        id: [{required: true, message: '请选择还款期数', trigger: 'change'}],
      },
      repaymentList: []
    }
  },
  methods: {
    resetForm(formName) {
      this.entity = {
        orderNo: this.orderNo,
        id: ''
      }
      //清除验证
      this.$refs[formName].clearValidate()
    },
    openFun() {
      this.resetForm('flowRef')
      orderRepayList(this.orderNo, 0).then(res => {
        this.repaymentList = res
      })
    },
    //  提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isLoading = true
          orderRepay(this.entity.id).then(() => {
            successMsg('操作成功')
            this.visible = false
            this.$emit('operate:success')
            this.isLoading = false
          }).catch(() => {
            this.isLoading = false
          })
        }
      })
    },
    stringRepayment(item) {
      let str = '';
      const money = item.principal + item.interest + item.interestPenalty;
      str = item.num + '期 ' + item.date + " " + money + '元';
      str = str + '(本金:' + item.principal + '+利息:' + item.interest;
      if (item.interestPenalty > 0) {
        str = str + '+逾期罚息: ' + item.interestPenalty + ')';
      } else {
        str = str + ')';
      }
      return str;
    }
  }
}
</script>

<style scoped>
::v-deep .vue-treeselect__control {
  height: 28px;
}

::v-deep .el-form-item__content {
  line-height: 28px;
  font-size: 12px;
}
</style>
